define.alias("shared/components/shared/video-thumbnail-list", "calendar/components/shared/video-thumbnail-list");